/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import css from 'styled-jsx/css';
import { colors, sizes, borders, shadows, theme } from '@styles/theme';

export default css.global`
  body {
    font: ${`400 ${sizes.base} 'Source Sans Pro', arial`};
    background-color: ${colors.white};
    margin: 0;
  }
  body * {
    max-width: 100%;
  }
  footer {
    height: ${sizes.common};
  }
  *:focus {
    outline-width: 3px;
    outline-color: ${colors.antdHover};
  }
  svg {
    box-sizing: content-box;
  }
  label {
    display: 'inline-block';
  }
  p {
    margin: 0;
    line-height: normal;
  }
  strong {
    font-weight: 600;
  }

  .App {
    min-width: 1200px;
    width: 100%;
    height: auto;
    overflow: none;
  }

  .page-layout {
    width: 1440px;
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: center;
  }

  .main-content {
    width: 100%;
    height: 100%;
    min-height: 765px;
    background-color: ${colors.alabaster};
    padding: 0 ${sizes.kilo};
  }

  .content-header {
    margin-top: ${sizes.exa};
    margin-bottom: ${sizes.exa};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    font-weight: 600;
  }

  h2,
  h3 {
    font: 'Source Sans Pro, arial';
  }

  h3 {
    font-size: ${sizes.mega};
    height: ${sizes.mega};
  }
  h4 {
    font-size: ${sizes.hecto};
  }

  h5 {
    font-size: ${sizes.base};
  }

  .ds-page-header {
    margin-bottom: ${sizes.giga};
  }

  .font-base {
    font: ${`400 ${sizes.base}/1.4s 'Source Sans Pro', arial`};
    letter-spacing: normal;
    color: ${colors.secondary};
  }

  .clearfix::after {
    clear: both;
    content: '';
    display: block;
  }

  .centered-flex {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .horizontal-centered-flex {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .vertical-centered-flex {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-primary {
    height: ${sizes.common};
    font-size: ${sizes.base};
    font-weight: 600;
    padding: ${sizes.deci};
    text-align: center;
    text-transform: uppercase;
    color: ${colors.white};
    background-color: ${colors.primary};
    border-color: ${colors.primary};
    border-style: none;
    border-radius: 2px;
    user-select: none;
    cursor: pointer;
  }

  .btn-primary:hover {
    background-color: ${colors.appleBlossom};
  }

  .btn-accent {
    border: none;
    &:hover,
    &:focus,
    &:active {
      color: ${colors.white};
      opacity: 0.75;
    }
  }

  .btn-accent.positive {
    background: ${theme.colors.accentPositive};
  }

  .btn-accent.informative {
    background: ${theme.colors.accentInformative};
  }

  .btn-accent.negative {
    background: ${theme.colors.accentNegative};
  }

  .link-primary {
    font-weight: 600;
    color: ${colors.primary};
    text-decoration: none;
    cursor: pointer;
    &:visited {
      color: ${colors.primary};
    }
    &:hover {
      text-decoration: underline;
    }
  }

  .link-secondary {
    margin: 0;
    color: ${colors.secondary};
    text-decoration: underline;
    cursor: pointer;
    &:visited {
      color: ${colors.secondary};
    }
    &:hover {
      color: ${colors.primary};
    }
  }

  .label-input-field {
    margin-bottom: ${sizes.deka};
    input {
      height: ${sizes.common};
      width: 100%;
      display: block;
      border: ${borders.midGrey};
      margin: ${`${sizes.centi} 0 0`};
      box-shadow: ${shadows.lighterBlack};
      font: ${`400 italic ${sizes.base} 'Source Sans Pro', arial`};
      padding: ${sizes.centi};
    }
    .invalid-feedback {
      font-size: ${sizes.deci};
      font-style: italic;
      color: ${colors.tomato};
    }
  }
  /* For A11y purposes to hide AT's descriptive content out of the page flow */
  /* TODO: Check if this one works in IE11 the most used with clip-path probably not*/
  .sr-only {
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
    clip: rect(0 0 0 0);
    overflow: hidden;
    position: absolute;
  }

  /* Ant globals */
  .ant-select-clear {
    top: 21px;
    right: 30px;
  }
  .ant-pagination-prev,
  .ant-pagination-next {
    .ant-pagination-item-link {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .ant-modal-confirm-body {
    > .anticon {
      margin-top: 3px;
    }
    > .anticon + .ant-modal-confirm-title {
      font-weight: 600;
      font-size: 20px;
      + .ant-modal-confirm-content {
        margin: 0;
      }
    }
  }
  .ant-modal-header {
    border-bottom: none;
  }

  .ant-modal-footer {
    border-top: none;
  }

  .ant-modal-close-x {
    color: #ef6461;
    font-size: 21px;
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    display: none;
  }

  .main-button-icon-primary {
    color: #ef6461 !important;
    font-size: 21px !important;
    margin-right: 10px !important;
  }

  .custom-button-primary {
    border: 2px solid #ef6461 !important;
    color: #ef6461 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  .ant-table-thead {
    font-size: 14px;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 15px 5px;
  }

  #DropdownRef {
    overflow-x: hidden;
  }

  #DropdownRef > span {
    max-width: 90%;
    overflow-x: hidden;
  }

  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {
    display: inline-block;
    margin-right: 4px;
    color: #c91432;
    font-size: 16px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: '*';
  }

  .custom-required-input .ant-form-item-label::after {
    display: inline-block;
    margin-left: 4px;
    color: #c91432;
    font-size: 16px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: '*';
  }

  .confirm-box__content {
    padding: 20px;
    width: 400px;
  }
  .confirm-box__content > span {
    font-size: 18px;
  }

  .confirm-box__actions {
    margin-top: 20px;
  }
  .confirm-box__actions > button {
    border: 2px solid #ef6461 !important;
    color: #ef6461 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    background-color: white;
    cursor: pointer;
    height: ${sizes.common};
    font-size: ${sizes.base};
    text-align: center;
    text-transform: uppercase;
    padding: ${sizes.deci};
    font-weight: 600;
  }

  .confirm-box__actions > button:first-child {
    color: white !important;
    background-color: ${colors.primary};
    border-color: ${colors.primary};
    border-style: none;
    border-radius: 2px;
    user-select: none;
    cursor: pointer;
  }

  button {
    cursor: pointer;
  }

  .ant-spin-dot-item {
    background-color: black;
  }
`;
